module.exports = __webpack_public_path__ + "img/data_moun_lq.698d9588.png";